<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">
          Licitação: {{ licitacao.tipoLicitacao.nome || null }}
          {{ licitacao.numero || "" }}/{{ licitacao.ano || ""}}
        </h4>
      </v-alert>

      <v-form :disabled="!userHasPermission()" v-model="valid" lazy-validation ref="form">
        <v-container>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                type="number"
                label="Número"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="licitacao.numero"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                type="number"
                label="Ano"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="licitacao.ano"
              ></v-text-field>
            </v-col>

            <v-col md="4" style="margin-top: 1.1%">
              <v-select
                solo
                dense
                v-model="licitacao.tipoLicitacao"
                :items="tiposLic"
                item-text="nome"
                item-value="tipoLicitacaoId"
                label="Tipo de Licitação"
                :rules="[(v) => v.tipoLicitacaoId!=null || 'Este campo é obrigatório!']"
                return-object
              ></v-select>
            </v-col>

            <v-col md="4" style="margin-top: 1.1%">
              <v-select
                solo
                dense
                v-model="licitacao.situacaoLicitacao"
                :items="sitList"
                item-text="nome"
                item-value="situacaoLicitacaoId"
                label="Situação"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                return-object
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="assuntoTextArea"
                label="Assunto da Licitação"
                v-model="licitacao.assunto"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <ckeditor  @ready="onReady" :editor="editor" v-model="licitacao.texto" 
              :config="editorConfig"></ckeditor>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="2">
              <v-menu
                v-model="dPicker1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                    type="date"
                    mask="dd/MM/yyyy"
                    v-model="licitacao.dataPublicacao"
                    label="Data de Publicação"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="licitacao.dataPublicacao" @input="dPicker1 = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="2">
              <v-menu
                v-model="dPicker2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                    type="date"
                    mask="dd/MM/yyyy"
                    v-model="licitacao.dataValidade"
                    label="Data de Validade"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="licitacao.dataValidade" @input="dPicker2 = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <!-- ============= COMEÇO DATA-TABLE COM MODAL =========================================-->
          <template>
            <v-data-table :headers="headers" :items="licitacao.itensLicitacao" class="elevation-1">
              <template v-slot:item.dataFormatada="{ item }">
                <span>{{new Date($moment(item.data).format()).toLocaleDateString()}}</span>
              </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Anexos</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                      :disabled="!userHasPermission()">Novo Anexo</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col>
                              <v-text-field
                                label="Descrição"
                                v-model="itemLicitacao.descricao"
                                required
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-text-field
                                label="Link Externo"
                                v-model="itemLicitacao.linkExterno"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-text-field label="Externo" v-model="itemLicitacao.externo" />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-file-input
                                required
                                v-model="arquivo"
                                label="UPLOAD"
                                placeholder="Selecione seu Arquivo"
                                show-size
                                truncate-length="50"
                              ></v-file-input>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="salvarDialog">Salvar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="headline">Você confirma a exclusão do anexo??</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }"> <!-- TEMPLATE PARA ATIVAR TOOLTIP -->
                    <v-icon
                      :disabled="!item.itemLicitacaoId"
                      v-bind="attrs"
                      v-on="on"
                      medium
                      class="mr-2"
                      @click="download(item)"
                    >mdi-download</v-icon>
                  </template> <!-- TEMPLATE TOOLTIP -->
                  <span>Download</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" size="22" @click="deleteItem(item)"
                    :disabled="!userAdm()">mdi-delete</v-icon>
                  </template>
                  <span>Deletar</span>
                </v-tooltip>
                <!-- <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon> -->
              </template>
            </v-data-table>
          </template>
          <!-- ============= FIM DATA-TABLE COM MODAL ===============================-->
          <v-row>
            <v-col>
              <v-btn color="primary" small depressed @click="salvar" :disabled="!userHasPermission()">Salvar</v-btn>
              <span></span>
              <v-btn
                style="margin-left: 2%"
                color="primary"
                small
                depressed
                to="/licitacoes"
              >Cancelar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </app-layout>
</template>

<script>
import licitacaoService from "@/service/LicitacaoService"
import Licitacao from "@/model/licitacao"
import ItemLicitacao from "@/model/itemLicitacao"
import Editor from 'ckeditor5-build-decoupled-document-base64-imageresize';
export default {

  data () {
    return {
      editor: Editor,
      editorConfig: {},

      dialog: false,
      dialogDelete: false,
      dPicker1: false,
      dPicker2: false,
      editedIndex: -1,

      valid: false,
      id: this.$route.params.id,
      itemLicitacao: ItemLicitacao(),
      licitacao: Licitacao(),
      tiposLic: [],
      sitList: [],
      arquivos: [],
      arquivo: null,
      headers: [
        {
          align: "start",
          sortable: false,
        },
        { text: "Cód.", value: "itemLicitacaoId" },
        { text: "Descrição", value: "descricao" },
        { text: "Arquivo", value: "arquivo" },
        { text: "Data", value: "dataFormatada" },
        { text: "Ações", value: "actions", sortable: false, width: "10%" },
      ],
    };
  },
  methods: {
    onReady( editor )  {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
      );
    },

    validate () {
      this.$refs.form.validate();
    },
    download (item) {
      if (item.arquivo.length>0 && item.itemLicitacaoId != null) {
        licitacaoService.downloadAnexo(item.itemLicitacaoId)
      } else {
        alert("Este Anexo não possui arquivo para Download!")
      }
    },

    salvar () {
      this.valid = this.$refs.form.validate();
      if (this.valid) {

        licitacaoService
          .salvar(this.licitacao, this.arquivos)
          .then((result) => {
            (this.licitacao = result), alert("Licitação Salva!"),this.$router.push("/licitacoes");
          })
          .catch((err) => console.error(err.message));

      } else {
        alert("Informe os campos Obrigatórios!");
      }
    },

    //FUNÇÕES PARA MODAL 

    salvarDialog () {

      if (this.itemLicitacao.descricao.length === 0 || !this.itemLicitacao.descricao.trim()) {
        alert('Campo Descrição não pode ser nulo!')
        return
      }

      if (this.arquivo == null) {
        alert('Arquivo inválido!')
        return
      }

      this.itemLicitacao.arquivo = this.arquivo.name
      var moment = require('moment');
      var date = moment(new Date()).format('YYYY-MM-DD')
      this.itemLicitacao.data = date

      if (this.editedIndex > -1) {
        Object.assign(this.licitacao.itensLicitacao[this.editedIndex], this.itemLicitacao)
        this.arquivos.splice(this.editedIndex, 1, this.arquivo) //adiciona na posição correta
      } else {
        this.licitacao.itensLicitacao.push(this.itemLicitacao)
        this.arquivos.push(this.arquivo)
      }
      this.close()
    },

    editItem (item) {
      this.editedIndex = this.licitacao.itensLicitacao.indexOf(item)
      this.itemLicitacao = Object.assign({}, item)
      this.arquivo = this.arquivos[this.editedIndex]
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.licitacao.itensLicitacao.indexOf(item)
      this.itemLicitacao = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.licitacao.itensLicitacao.splice(this.editedIndex, 1)
      
      if(this.itemLicitacao.itemLicitacaoId ==null){ // ainda não salvou
         this.arquivos.splice(this.editedIndex, 1)
      }else{
        licitacaoService.excluirItemLicitacao(this.itemLicitacao.itemLicitacaoId)
          .then(res =>  res)
      }
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.itemLicitacao = Object.assign({}, new ItemLicitacao)
        this.arquivo = null
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.itemLicitacao = Object.assign({}, new ItemLicitacao)
        this.arquivo = null
        this.editedIndex = -1
      })
    },
  },

  mounted () {
    //created é chamado primeiro que mounted
  },
  created () {

    licitacaoService.findAllTipos()
      .then((result) => (this.tiposLic = result));

    licitacaoService.findAllSituacoes()
      .then((result) => (this.sitList = result));

    if (this.id != 0) {
      licitacaoService
        .buscarLicitacao(this.id)
        .then((result) => (this.licitacao = result))
        .catch((err) => console.error(err.message));
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Novo Anexo' : 'Editar Anexo'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },
};
</script>

<style>
</style>